import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=2cd45f4b&scoped=true&"
import script from "./ChannelInfo.vue?vue&type=script&lang=js&"
export * from "./ChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInfo.vue?vue&type=style&index=0&id=2cd45f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd45f4b",
  null
  
)

export default component.exports